import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { useLoadingContext } from '../../../utils/hooks/Context/LoadingContext'
import { REPOSITORY } from '../../../api/repository/Repository'
import { CheckCircleIcon } from '@chakra-ui/icons'

export function Quees() {
  const ref = useRef(null)

  const toast = useToast()

  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const [isOpen, setIsOpen] = useState(false)
  const [show, setShow] = useState(false)

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShow(false)
    }
  }

  const handleOpenModal = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.dashboard
      .SolicitudContactoDigital()
      .then(() => {
        setIsOpen(true)
      })
      .catch((error) => {
        console.error('Error enviando el correo:', error)
        toast({
          title: 'Error.',
          description: 'Hubo un problema al enviar la solicitud.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      })
      .finally(() => {
        handleCLoseLoading()
      })
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <Box position="relative" alignSelf="start">
      <Text
        mt={1}
        ml={1}
        color="#0086D6"
        cursor="pointer"
        variant="subtitle2"
        textDecoration="underline"
        onClick={() => setShow((old) => !old)}
      >
        Que es esto?
      </Text>

      {show && (
        <Box
          ref={ref}
          right={0}
          zIndex={10}
          width={482}
          marginTop={4}
          borderRadius={4}
          position="absolute"
          backgroundColor="#515151"
          boxShadow="6px 8px 7px 0px #00000040"
        >
          <Box
            width={0}
            height={0}
            top="-15px"
            right={10}
            position="absolute"
            borderLeft="10px solid transparent"
            borderRight="10px solid transparent"
            borderBottom="15px solid #515151"
          />
          <Box padding={3}>
            <Text variant="subtitle2" color="#fff">
              Porcentaje (%) de transacciones realizadas por tus colaboradores
              con su app amiPASS.
            </Text>
          </Box>
          <Box
            padding={2}
            backgroundColor="#74BF00"
            borderRadius="0px 0px 4px 4px"
          >
            <Text
              color="#fff"
              cursor="pointer"
              variant="caption2"
              textAlign="center"
              onClick={handleOpenModal}
              textDecoration="underline"
            >
              Súmate a cuidar el planeta, eliminando la impresión de tarjetas
              Aquí!
            </Text>
          </Box>
        </Box>
      )}

      <Modal isOpen={isOpen} onClose={handleCloseModal} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader display="flex" alignItems="center">
            <CheckCircleIcon color="green.500" boxSize={6} />
          </ModalHeader>
          <ModalBody textAlign={'center'}>
            <b>Serás contactado por tu Ejecutiva.</b>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleCloseModal}>
              Aceptar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}
